import { render, staticRenderFns } from "./CongressParticipation.vue?vue&type=template&id=0940f4e6"
import script from "./CongressParticipation.vue?vue&type=script&lang=js"
export * from "./CongressParticipation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports